import React, { Fragment, useState, useEffect } from "react";
import Breadcrumb from "../../components/common/breadcrumb";
import { useSelector, useDispatch } from "react-redux";
import DataTable from "react-data-table-component";
import NumberFormat from "react-number-format";
import Time from "react-time-format";
import { change_Lang } from "../../actions/Helper_action";
import { Search } from "react-feather";
import {
  Get_List_Bills,
  Take_Money_View,
  TakeMoney_Delete_Status,
} from "../../actions/Invoice_action";
import Swal from "sweetalert2";
import _ from "lodash";
import { Button, Input, Select, Tooltip, Modal } from "antd";
import ReView_TakeMoney from "./ViewAllBills/ReView_TakeMoney";
import { Link } from "react-router-dom";
const ListTakeMoney = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(Get_List_Bills());
  }, []);
  const lang = useSelector((state) => state.HelperReducer.lang);
  const list_bills = useSelector((state) => state.InvoiceReducer.list_bills);
  const takemoney_status = useSelector(
    (state) => state.InvoiceReducer.takemoney_status
  );
  const [search, setsearch] = useState("");
  const [select_property, setselect_property] = useState("");
  const [select_box, setselect_box] = useState("");
  const [isModalVisible, setisModalVisible] = useState(false);
  const showModal = (id) => {
    dispatch(Take_Money_View(id));
    setisModalVisible(true);
  };
  const handleCancel = () => {
    setisModalVisible(false);
  };
  const onDelete_TakeMoney = (id) => {
    return Swal.fire({
      title: dispatch(change_Lang("Are you sure")),
      html: `<label class="fk">${dispatch(
        change_Lang("You won't be able to delete this!")
      )}</label>`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: dispatch(change_Lang("Yes, delete it")),
      cancelButtonText: dispatch(change_Lang("cancel")),
      confirmButtonClass: "fk",
      cancelButtonClass: "fk",
      customClass: {
        title: "fk",
        content: "fk",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(TakeMoney_Delete_Status(id));
        Swal.fire({
          title: dispatch(change_Lang("Delete")),
          text: dispatch(
            change_Lang("Your work has been successfully completed")
          ),
          timer: 1000,
          icon: "success",
          customClass: {
            title: "fk",
            content: "fk",
          },
        });
      }
    });
  };

  const handleChange_Property = (value, setstate) => {
    setstate(value);
  };
  const TakeMoney_getPrint = () => {
    window.setTimeout("window.print()", 4000);
  };
  const TakeMoneyList_getPrint = () => {
    window.setTimeout("window.print()", 4000);
  };
  const datas = list_bills
    .filter((data) => {
      if (data.status !== "delete") {
        if (isNaN(search)) {
          if (
            data.Money_provider &&
            data.Money_provider.toLowerCase().startsWith(search.toLowerCase())
          ) {
            return (
              data.Money_provider &&
              data.Money_provider.toLowerCase().startsWith(search.toLowerCase())
            );
          } else if (data.num && data.num.toString().startsWith(search)) {
            return data.num && data.num.toString().startsWith(search);
          }
        } else if (select_property === "Monthly rent invoice") {
          return data.type === "Monthly rent invoice";
        } else if (select_property === "Service Bill") {
          return data.type === "Service Bill";
        } else if (select_property === "Insurance Bill") {
          return data.type === "Insurance Bill";
        } else if (select_property === "Sell") {
          return data.type === "Sell";
        } else if (select_property === "Arabun") {
          return data.type === "Arabun";
        } else if (select_property === "Buy") {
          return data.type === "Buy";
        } else if (select_property === "comision") {
          return data.type === "comision";
        } else if (select_property === "investor") {
          return data.type === "investor";
        } else if (select_box === "off") {
          return data.box_status === "off";
        } else if (select_box === "on") {
          return data.box_status === "on";
        } else {
          if (data.Amount.toString().startsWith(search)) {
            return data.Amount.toString().startsWith(search);
          } else if (data.num && data.num.toString().startsWith(search)) {
            return data.num && data.num.toString().startsWith(search);
          } else {
            return (
              data.invoice_No && data.invoice_No.toString().startsWith(search)
            );
          }
        }
      }
    })
    .filter((el) => {
      if (select_box !== "" && select_property !== "" && search !== "") {
        return (
          el.box_status === select_box &&
          el.type === select_property &&
          (el.Money_provider === search ||
            el.num === search ||
            el.Amount === search ||
            el.invoice_No === search)
        );
      } else if (select_box !== "" && select_property !== "") {
        return el.box_status === select_box && el.type === select_property;
      } else {
        return el;
      }
    })
    .map((el, i) => {
      return {
        id: el.invoice_No,
        action: (
          <>
            <Tooltip title="View">
              <Button
                style={{ background: "#efefed", color: "#295a68" }}
                shape="circle"
                onClick={() => showModal(el._id)}
                icon={
                  <i
                    style={{
                      cursor: "pointer",
                    }}
                    class="fas fa-eye text-center mt-1"
                  ></i>
                }
              />
            </Tooltip>
            {/* &nbsp;
            <Tooltip title="Print">
              <Link to={`/print_TakeMoney/${el._id}/${el.invoice_No}`}>
                <Button
                  style={{ background: "#efefed", color: "#295a68" }}
                  shape="circle"
                  onClick={() => {
                    dispatch(Take_Money_View(el._id, el.invoice_No));
                    TakeMoney_getPrint();
                  }}
                  icon={
                    <i
                      style={{
                        cursor: "pointer",
                      }}
                      class="fas fa-print text-center mt-1"
                    ></i>
                  }
                />
              </Link>
            </Tooltip> */}
            &nbsp;
            <Tooltip title="Delete">
              <Button
                style={{ background: "#efefed", color: "#295a68" }}
                shape="circle"
                onClick={() => onDelete_TakeMoney(el._id)}
                icon={
                  <i
                    style={{
                      cursor: "pointer",
                    }}
                    class="fas fa-ban text-center mt-1"
                  ></i>
                }
              />
            </Tooltip>
          </>
        ),
        firstName: (
          <span className={`${lang === "en" ? "" : "fk"}`}>
            {el.Money_provider}
          </span>
        ),
        user: (
          <span className={`${lang === "en" ? "" : "fk"}`}>
            {`${el.agentId && el.agentId.fname} ${
              el.agentId && el.agentId.lname
            }`}
          </span>
        ),
        branch: (
          <span className={`${lang === "en" ? "" : "fk"}`}>
            {el.branchId.name}
          </span>
        ),
        currency: (
          <span className={`${lang === "en" ? "" : "fk"}`}>
            {dispatch(change_Lang(el.currency))}
          </span>
        ),
        box_status: (
          <span
            className={`${lang === "en" ? "" : "fk"}`}
            style={{
              color: el.box_status !== "off" ? "#295a68" : "black",
              fontWeight: "bold",
              fontSize: "14px",
            }}
          >
            {dispatch(change_Lang(el.box_status))}
          </span>
        ),
        type: (
          <span
            className={`${lang === "en" ? "font-weight-bold" : "fk"}`}
            style={{
              fontWeight: "bolder",
              color: `${
                el.type === "Monthly fee receipts"
                  ? "#295a68"
                  : el.type === "Service Bill"
                  ? "#295a68"
                  : "#295a68"
              }`,
            }}
          >
            {dispatch(change_Lang(el.type))}
          </span>
        ),
        lastPrice: (
          <NumberFormat
            displayType="text"
            thousandSeparator={true}
            value={el.Amount}
            className={`${lang === "en" ? "" : "fk"}`}
            prefix={el.currency !== "dolar" ? " ID" : " $"}
          />
        ),
        date: (
          <Time
            value={el.createdAt}
            format="YYYY-MM-DD"
            style={{ color: "black" }}
            className={`${lang === "en" ? "" : "fk"}`}
          />
        ),
        property_detail: (
          <>
            <span className={`${lang === "en" ? "" : "fk"}`}>
              {el.property && dispatch(change_Lang(el.property))}
            </span>
            &nbsp;-&nbsp;
            <span className={`${lang === "en" ? "" : "fk"}`}>{el.num}</span>
          </>
        ),
      };
    });
  const columns = [
    {
      name: dispatch(change_Lang("id")),
      selector: "id",
      sortable: true,
      center: true,
      compact: true,
      width: "90px",
    },
    {
      name: dispatch(change_Lang("received from Mr")),
      selector: "firstName",
      center: true,
      compact: true,
    },
    {
      name: dispatch(change_Lang("Name of Branch")),
      selector: "branch",
      center: true,
      compact: true,
    },
    {
      name: dispatch(change_Lang("Property Detail")),
      selector: "property_detail",
      center: true,
      compact: true,
    },
    {
      name: dispatch(change_Lang("type")),
      selector: "type",
      center: true,
      compact: true,
      width: "100px",
    },
    {
      name: dispatch(change_Lang("pr_price")),
      selector: "lastPrice",
      center: true,
      compact: true,
      width: "100px",
    },
    {
      name: dispatch(change_Lang("Go to the box.")),
      selector: "box_status",
      center: true,
      compact: true,
      width: "100px",
    },
    {
      name: dispatch(change_Lang("date")),
      selector: "date",
      center: true,
      compact: true,
    },
    {
      name: dispatch(change_Lang("User")),
      selector: "user",
      center: true,
      compact: true,
    },
    {
      name: dispatch(change_Lang("Action")),
      selector: "action",
      center: true,
      compact: true,
    },
  ];
  const customStyles = {
    header: {
      style: {
        minHeight: "0.1px",
        background: "#e3e9f2",
      },
    },
    headRow: {
      style: {
        background: "#e3e9f2",
      },
    },
    headCells: {
      style: {
        color: "black",
        fontSize: "14px",
      },
    },
  };
  const { Option } = Select;
  const Total = _.sumBy(list_bills, function (o) {
    if (o.status !== "delete") {
      if (
        select_box
          ? o.type === "comision" &&
            o.currency === "dolar" &&
            o.box_status === select_box
          : o.type === "comision" && o.currency === "dolar"
      ) {
        return Number(o.Amount);
      } else {
        return 0;
      }
    }
  });
  const Total_Rent = _.sumBy(list_bills, function (o) {
    if (o.status !== "delete") {
      if (
        select_box
          ? o.type === "Monthly rent invoice" &&
            o.currency === "dolar" &&
            o.box_status === select_box
          : o.type === "Monthly rent invoice" && o.currency === "dolar"
      ) {
        return Number(o.Amount);
      } else {
        return 0;
      }
    }
  });
  const Total_Sell = _.sumBy(list_bills, function (o) {
    if (o.status !== "delete") {
      if (
        select_box
          ? o.type === "Sell" &&
            o.currency === "dolar" &&
            o.box_status === select_box
          : o.type === "Sell" && o.currency === "dolar"
      ) {
        return Number(o.Amount);
      } else {
        return 0;
      }
    }
  });
  const Total_Service = _.sumBy(list_bills, function (o) {
    if (o.status !== "delete") {
      if (
        select_box
          ? o.type === "Service Bill" &&
            o.currency === "dolar" &&
            o.box_status === select_box
          : o.type === "Service Bill" && o.currency === "dolar"
      ) {
        return Number(o.Amount);
      } else {
        return 0;
      }
    }
  });
  const Total_Buy = _.sumBy(list_bills, function (o) {
    if (o.status !== "delete") {
      if (
        select_box
          ? o.type === "Buy" &&
            o.currency === "dolar" &&
            o.box_status === select_box
          : o.type === "Buy" && o.currency === "dolar"
      ) {
        return Number(o.Amount);
      } else {
        return 0;
      }
    }
  });
  const Total_Arabun = _.sumBy(list_bills, function (o) {
    if (o.status !== "delete") {
      if (
        select_box
          ? o.type === "Arabun" &&
            o.currency === "dolar" &&
            o.box_status === select_box
          : o.type === "Arabun" && o.currency === "dolar"
      ) {
        return Number(o.Amount);
      } else {
        return 0;
      }
    }
  });
  const Total_sayfty = _.sumBy(list_bills, function (o) {
    if (o.status !== "delete") {
      if (
        select_box
          ? o.type === "Insurance Bill" &&
            o.currency === "dolar" &&
            o.box_status === select_box
          : o.type === "Insurance Bill" && o.currency === "dolar"
      ) {
        return Number(o.Amount);
      } else {
        return 0;
      }
    }
  });
  const Total_Investor_Dolar = _.sumBy(list_bills, function (o) {
    if (o.status !== "delete") {
      if (
        select_box
          ? o.type === "investor" &&
            o.currency === "dolar" &&
            o.box_status === select_box
          : o.type === "investor" && o.currency === "dolar"
      ) {
        return Number(o.Amount);
      } else {
        return 0;
      }
    }
  });
  const Tow_One = _.add(Total, Total_Investor_Dolar);
  const Tow_Two = _.add(Total_Rent, Total_Sell);
  const Tow_Three = _.add(Total_Service, Total_Buy);
  const Tow_Four = _.add(Total_Arabun, Total_sayfty);
  const Tow_Five = _.add(Tow_One, Tow_Two);
  const Tow_Six = _.add(Tow_Three, Tow_Four);
  const Tow_Seven = _.add(Tow_Five, Tow_Six);
  const Total_Dinar = _.sumBy(list_bills, function (o) {
    if (o.status !== "delete") {
      if (
        select_box
          ? o.type === "comision" &&
            o.currency !== "dolar" &&
            o.box_status === select_box
          : o.type === "comision" && o.currency !== "dolar"
      ) {
        return Number(o.Amount);
      } else {
        return 0;
      }
    }
  });
  const Total_Rent_Dinar = _.sumBy(list_bills, function (o) {
    if (o.status !== "delete") {
      if (
        select_box
          ? o.type === "Monthly rent invoice" &&
            o.currency !== "dolar" &&
            o.box_status === select_box
          : o.type === "Monthly rent invoice" && o.currency !== "dolar"
      ) {
        return Number(o.Amount);
      } else {
        return 0;
      }
    }
  });
  const Total_Sell_Dinar = _.sumBy(list_bills, function (o) {
    if (o.status !== "delete") {
      if (
        select_box
          ? o.type === "Sell" &&
            o.currency !== "dolar" &&
            o.box_status === select_box
          : o.type === "Sell" && o.currency !== "dolar"
      ) {
        return Number(o.Amount);
      } else {
        return 0;
      }
    }
  });
  const Total_Service_Dinar = _.sumBy(list_bills, function (o) {
    if (o.status !== "delete") {
      if (
        select_box
          ? o.type === "Service Bill" &&
            o.currency !== "dolar" &&
            o.box_status === select_box
          : o.type === "Service Bill" && o.currency !== "dolar"
      ) {
        return Number(o.Amount);
      } else {
        return 0;
      }
    }
  });
  const Total_Buy_Dinar = _.sumBy(list_bills, function (o) {
    if (o.status !== "delete") {
      if (
        select_box
          ? o.type === "Buy" &&
            o.currency !== "dolar" &&
            o.box_status === select_box
          : o.type === "Buy" && o.currency !== "dolar"
      ) {
        return Number(o.Amount);
      } else {
        return 0;
      }
    }
  });
  const Total_Arabun_Dinar = _.sumBy(list_bills, function (o) {
    if (o.status !== "delete") {
      if (
        select_box
          ? o.type === "Arabun" &&
            o.currency !== "dolar" &&
            o.box_status === select_box
          : o.type === "Arabun" && o.currency !== "dolar"
      ) {
        return Number(o.Amount);
      } else {
        return 0;
      }
    }
  });
  const Total_sayfty_Dinar = _.sumBy(list_bills, function (o) {
    if (o.status !== "delete") {
      if (
        select_box
          ? o.type === "Insurance Bill" &&
            o.currency !== "dolar" &&
            o.box_status === select_box
          : o.type === "Insurance Bill" && o.currency !== "dolar"
      ) {
        return Number(o.Amount);
      } else {
        return 0;
      }
    }
  });
  const Total_Investor_Dinar = _.sumBy(list_bills, function (o) {
    if (o.status !== "delete") {
      if (
        select_box
          ? o.type === "investor" &&
            o.currency !== "dolar" &&
            o.box_status === select_box
          : o.type === "investor" && o.currency !== "dolar"
      ) {
        return Number(o.Amount);
      } else {
        return 0;
      }
    }
  });
  const Tow_One_Dinar = _.add(Total_Dinar, Total_Investor_Dinar);
  const Tow_Two_Dinar = _.add(Total_Rent_Dinar, Total_Sell_Dinar);
  const Tow_Three_Dinar = _.add(Total_Service_Dinar, Total_Buy_Dinar);
  const Tow_Four_Dinar = _.add(Total_Arabun_Dinar, Total_sayfty_Dinar);
  const Tow_Five_Dinar = _.add(Tow_One_Dinar, Tow_Two_Dinar);
  const Tow_Six_Dinar = _.add(Tow_Three_Dinar, Tow_Four_Dinar);
  const Tow_Seven_Dinar = _.add(Tow_Five_Dinar, Tow_Six_Dinar);
  return (
    <>
      <Fragment>
        <Breadcrumb
          title={dispatch(change_Lang("list taking money"))}
          parent={dispatch(change_Lang("List of Bills"))}
        />
        {takemoney_status !== true ? (
          <div className="loader-container">
            <div className="spinner"></div>
          </div>
        ) : (
          <>
            <div
              className={`${
                lang === "en" ? "container-fluid" : "container-fluid fk"
              }`}
            >
              <div className="row">
                <div className="col-xs-12 col-sm-12 ">
                  <div className="card" style={{ background: "" }}>
                    <div className="row ">
                      <div className="col-md-4 card-header d-flex justify-content-start">
                        <Select
                          onChange={(e) =>
                            handleChange_Property(e, setselect_property)
                          }
                          value={select_property}
                          defaultValue={dispatch(change_Lang("type"))}
                          className="fk text-center"
                          size="middle"
                          showSearch
                          optionFilterProp="children"
                          filterOption={true}
                          style={{
                            fontSize: "14px",
                            borderBottomColor: "#052f43",
                            width: "200px",
                          }}
                          showArrow={false}
                        >
                          <Option className="fk" value={""}>
                            {dispatch(change_Lang("type"))}
                          </Option>
                          <Option className="fk" value="Monthly rent invoice">
                            {dispatch(change_Lang("Monthly rent invoice"))}
                          </Option>
                          <Option className="fk" value="Service Bill">
                            {dispatch(change_Lang("Service Bill"))}
                          </Option>
                          <Option className="fk" value="Insurance Bill">
                            {" "}
                            {dispatch(change_Lang("Insurance Bill"))}
                          </Option>
                          <Option className="fk" value="Sell">
                            {" "}
                            {dispatch(change_Lang("Sell"))}
                          </Option>
                          <Option className="fk" value="Buy">
                            {" "}
                            {dispatch(change_Lang("Buy"))}
                          </Option>
                          <Option className="fk" value="Arabun">
                            {" "}
                            {dispatch(change_Lang("Arabun"))}
                          </Option>
                          <Option className="fk" value="comision">
                            {" "}
                            {dispatch(change_Lang("comision"))}
                          </Option>
                          <Option className="fk" value="investor">
                            {" "}
                            {dispatch(change_Lang("investor"))}
                          </Option>
                        </Select>
                        &nbsp;
                        <Select
                          onChange={(e) =>
                            handleChange_Property(e, setselect_box)
                          }
                          value={select_box}
                          defaultValue={dispatch(change_Lang("Go to the box."))}
                          className="fk text-center"
                          size="middle"
                          showSearch
                          optionFilterProp="children"
                          filterOption={true}
                          style={{
                            fontSize: "14px",
                            borderBottomColor: "#052f43",
                            width: "200px",
                          }}
                          showArrow={false}
                        >
                          <Option className="fk" value={""}>
                            {dispatch(change_Lang("Go to the box."))}
                          </Option>
                          <Option className="fk" value="on">
                            {dispatch(change_Lang("on"))}
                          </Option>
                          <Option className="fk" value="off">
                            {dispatch(change_Lang("off"))}
                          </Option>
                        </Select>{" "}
                        &nbsp;&nbsp;
                        <Link
                          onClick={TakeMoneyList_getPrint}
                          to={`/Print_all_takemoney/${
                            select_property ? select_property : "all"
                          }/${select_box ? select_box : "all"}`}
                        >
                          <Button
                            title={dispatch(change_Lang("Print"))}
                            style={{
                              background: "#efefed",
                              color: "#295a68",
                              border: "none",
                            }}
                            icon={
                              <i class="fa fa-print" aria-hidden="true"></i>
                            }
                          />
                        </Link>
                      </div>
                      <div className="col-md-5 card-header">
                        <div
                          className=" text-center mt-2"
                          style={{ background: "" }}
                        >
                          <h3 style={{ fontWeight: "bold", color: "#295a68" }}>
                            {dispatch(change_Lang("list taking money"))}
                          </h3>
                        </div>
                      </div>
                      <div
                        className="col-md-3 m-auto"
                        style={{ background: "" }}
                      >
                        <div className="form-group form-inline d-flex justify-content-center">
                          <Input
                            type="text"
                            name="search"
                            value={search}
                            onChange={(e) => setsearch(e.target.value)}
                            size="middle"
                            placeholder={dispatch(change_Lang("Search"))}
                            autoComplete="off"
                            className="mt-2 ml-2"
                            style={{ width: "180px" }}
                            prefix={<Search color="lightgray" />}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="user-status table-responsive latest-order-table">
                      <DataTable
                        columns={columns}
                        className={`${lang === "en" ? "" : "fk"}`}
                        customStyles={customStyles}
                        data={datas}
                        pagination="true"
                        striped
                      />
                    </div>
                    <br />
                    <div class="container">
                      <ul class="responsive-table">
                        <li class="table-header">
                          <div class="col d-flex justify-content-center">
                            کرێ $
                          </div>
                          <div class="col d-flex justify-content-center">
                            خزمەتگوزاری $
                          </div>
                          <div class="col d-flex justify-content-center">
                            دڵنیایی $
                          </div>
                          <div class="col d-flex justify-content-center">
                            فرۆشتن $
                          </div>
                          <div class="col d-flex justify-content-center">
                            کڕین $
                          </div>
                          <div class="col d-flex justify-content-center">
                            عربون $
                          </div>
                          <div class="col d-flex justify-content-center">
                            عمولە $
                          </div>
                          <div class="col d-flex justify-content-center">
                            وەبەرهێنەر $
                          </div>
                          <div class="col d-flex justify-content-center">
                            کۆی پارە $
                          </div>
                        </li>
                        <td></td>
                        <li class="table-row">
                          <div
                            class="col d-flex justify-content-center"
                            data-label="Job Id"
                          >
                            <NumberFormat
                              displayType="text"
                              thousandSeparator={true}
                              value={Total_Rent}
                              className={`${lang === "en" ? "" : "fk"}`}
                              prefix="$"
                            />
                          </div>
                          <div
                            class="col d-flex justify-content-center"
                            data-label="Job Id"
                          >
                            <NumberFormat
                              displayType="text"
                              thousandSeparator={true}
                              value={Total_Service}
                              className={`${lang === "en" ? "" : "fk"}`}
                              prefix="$"
                            />
                          </div>
                          <div
                            class="col d-flex justify-content-center"
                            data-label="Job Id"
                          >
                            <NumberFormat
                              displayType="text"
                              thousandSeparator={true}
                              value={Total_sayfty}
                              className={`${lang === "en" ? "" : "fk"}`}
                              prefix="$"
                            />
                          </div>
                          <div
                            class="col d-flex justify-content-center"
                            data-label="Job Id"
                          >
                            <NumberFormat
                              displayType="text"
                              thousandSeparator={true}
                              value={Total_Sell}
                              className={`${lang === "en" ? "" : "fk"}`}
                              prefix="$"
                            />
                          </div>
                          <div
                            class="col d-flex justify-content-center"
                            data-label="Job Id"
                          >
                            <NumberFormat
                              displayType="text"
                              thousandSeparator={true}
                              value={Total_Buy}
                              className={`${lang === "en" ? "" : "fk"}`}
                              prefix="$"
                            />
                          </div>
                          <div
                            class="col d-flex justify-content-center"
                            data-label="Job Id"
                          >
                            <NumberFormat
                              displayType="text"
                              thousandSeparator={true}
                              value={Total_Arabun}
                              className={`${lang === "en" ? "" : "fk"}`}
                              prefix="$"
                            />
                          </div>
                          <div
                            class="col d-flex justify-content-center"
                            data-label="Job Id"
                          >
                            <NumberFormat
                              displayType="text"
                              thousandSeparator={true}
                              value={Total}
                              className={`${lang === "en" ? "" : "fk"}`}
                              prefix="$"
                            />
                          </div>
                          <div
                            class="col d-flex justify-content-center"
                            data-label="Job Id"
                          >
                            <NumberFormat
                              displayType="text"
                              thousandSeparator={true}
                              value={Total_Investor_Dolar}
                              className={`${lang === "en" ? "" : "fk"}`}
                              prefix="$"
                            />
                          </div>
                          <div
                            class="col d-flex justify-content-center"
                            data-label="Job Id"
                          >
                            <NumberFormat
                              displayType="text"
                              thousandSeparator={true}
                              value={Tow_Seven}
                              className={`${lang === "en" ? "" : "fk"}`}
                              prefix="$"
                            />
                          </div>
                        </li>
                      </ul>
                    </div>
                    <br />
                    <div class="container">
                      <ul class="responsive-table">
                        <li class="table-header">
                          <div class="col d-flex justify-content-center">
                            کرێ ID
                          </div>
                          <div class="col d-flex justify-content-center">
                            خزمەتگوزاری ID
                          </div>
                          <div class="col d-flex justify-content-center">
                            دڵنیایی ID
                          </div>
                          <div class="col d-flex justify-content-center">
                            فرۆشتن ID
                          </div>
                          <div class="col d-flex justify-content-center">
                            کڕین ID
                          </div>
                          <div class="col d-flex justify-content-center">
                            عربون ID
                          </div>
                          <div class="col d-flex justify-content-center">
                            عمولە ID
                          </div>
                          <div class="col d-flex justify-content-center">
                            وەبەرهێنەر ID
                          </div>
                          <div class="col d-flex justify-content-center">
                            کۆی پارە ID
                          </div>
                        </li>
                        <td></td>
                        <li class="table-row">
                          <div
                            class="col d-flex justify-content-center"
                            data-label="Job Id"
                          >
                            <NumberFormat
                              displayType="text"
                              thousandSeparator={true}
                              value={Total_Rent_Dinar}
                              className={`${lang === "en" ? "" : "fk"}`}
                              prefix="IQD"
                            />
                          </div>
                          <div
                            class="col d-flex justify-content-center"
                            data-label="Job Id"
                          >
                            <NumberFormat
                              displayType="text"
                              thousandSeparator={true}
                              value={Total_Service_Dinar}
                              className={`${lang === "en" ? "" : "fk"}`}
                              prefix="IQD"
                            />
                          </div>
                          <div
                            class="col d-flex justify-content-center"
                            data-label="Job Id"
                          >
                            <NumberFormat
                              displayType="text"
                              thousandSeparator={true}
                              value={Total_sayfty_Dinar}
                              className={`${lang === "en" ? "" : "fk"}`}
                              prefix="IQD"
                            />
                          </div>
                          <div
                            class="col d-flex justify-content-center"
                            data-label="Job Id"
                          >
                            <NumberFormat
                              displayType="text"
                              thousandSeparator={true}
                              value={Total_Sell_Dinar}
                              className={`${lang === "en" ? "" : "fk"}`}
                              prefix="IQD"
                            />
                          </div>
                          <div
                            class="col d-flex justify-content-center"
                            data-label="Job Id"
                          >
                            <NumberFormat
                              displayType="text"
                              thousandSeparator={true}
                              value={Total_Buy_Dinar}
                              className={`${lang === "en" ? "" : "fk"}`}
                              prefix="IQD"
                            />
                          </div>
                          <div
                            class="col d-flex justify-content-center"
                            data-label="Job Id"
                          >
                            <NumberFormat
                              displayType="text"
                              thousandSeparator={true}
                              value={Total_Arabun_Dinar}
                              className={`${lang === "en" ? "" : "fk"}`}
                              prefix="IQD"
                            />
                          </div>
                          <div
                            class="col d-flex justify-content-center"
                            data-label="Job Id"
                          >
                            <NumberFormat
                              displayType="text"
                              thousandSeparator={true}
                              value={Total_Dinar}
                              className={`${lang === "en" ? "" : "fk"}`}
                              prefix="IQD"
                            />
                          </div>
                          <div
                            class="col d-flex justify-content-center"
                            data-label="Job Id"
                          >
                            <NumberFormat
                              displayType="text"
                              thousandSeparator={true}
                              value={Total_Investor_Dinar}
                              className={`${lang === "en" ? "" : "fk"}`}
                              prefix="IQD"
                            />
                          </div>
                          <div
                            class="col d-flex justify-content-center"
                            data-label="Job Id"
                          >
                            <NumberFormat
                              displayType="text"
                              thousandSeparator={true}
                              value={Tow_Seven_Dinar}
                              className={`${lang === "en" ? "" : "fk"}`}
                              prefix="IQD"
                            />
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Modal
              title={dispatch(change_Lang("Repayment bills"))}
              footer={false}
              className="fk"
              width={1200}
              open={isModalVisible}
              onOk={handleCancel}
              onCancel={handleCancel}
              bodyStyle={{ background: "#f6f8fa" }}
              centered
            >
              <ReView_TakeMoney handleCancel={handleCancel} />
            </Modal>
          </>
        )}
      </Fragment>
    </>
  );
};

export default ListTakeMoney;
